import { createRouter, createWebHistory } from 'vue-router'
import DepositPage from '../pages/DepositPage.vue'
import ViewAssetPage from '../pages/ViewAssetPage.vue'
import WithdrawPage from '../pages/WithdrawPage.vue'
import DashboardPage from '../pages/DashboardPage.vue'
import AssetClassesPage from '../pages/AssetClassesPage.vue'
import TokenListPage from '../pages/TokenListPage.vue'
import YieldDistributionPage from '../pages/YieldDistributionPage.vue'
import RewardsPage from '../pages/RewardsPage.vue'
import ApproveFundsPage from '../pages/ApproveFundsPage.vue'
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'dashboard',
      component: DashboardPage
    },
    {
      path: '/deposit',
      name: 'deposit',
      component: DepositPage
    },
    {
      path: '/deposit/:token_id',
      name: 'viewAsset',
      component: ViewAssetPage
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      component: WithdrawPage
    },
    {
      path: '/asset-classes',
      name: 'assetClasses',
      component: AssetClassesPage
    },
    {
      path: '/token-list',
      name: 'tokenList',
      component: TokenListPage
    },
    {
      path: '/yield-distribution',
      name: 'yieldDistribution',
      component: YieldDistributionPage
    },
    {
      path: '/rewards',
      name: 'Rewards',
      component: RewardsPage
    },
    {
      path: '/approve-funds',
      name: 'approveFunds',
      component: ApproveFundsPage
    }
  ]
})

export default router
